var app = angular.module("leonardo");

var UserRegisterController = function($scope, $state, $window, AuthService, NotificationService, ngDialog,
                                      FormErrorsService, AuthDataService) {

  $scope.redirect = $state.current.redirect;

  $scope.reset = function() {
    if ($scope.Form) $scope.Form.$setPristine();
    $scope.data = {
      client_instance: AuthDataService.getClientInstance(),
      //white_label: AuthDataService.getWhiteLabel(),
      first_name: '',
      last_name: '',
      password: '',
      email: ''
    };
    $scope.password2 = '';
  };

  $scope.validate = function() {
    if ($scope.data.password != $scope.password2) {
      NotificationService.error('Passwords don\'t match.');
      return false;
    }
    return true;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if (!$scope.validate()) return;
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var register = AuthService.register($scope.data);
    register.then(function() {
      var dialog = ngDialog.open({
        template: 'views/templates/dialog/account/created.html',
        className: 'ngdialog-theme-default dialog-user-created',
        showClose: false,
      });
      dialog.closePromise.then(function(){
        if ($scope.redirect) {
          $state.go('admin');
        }
        else {
          $window.open('https://www.leonardo247.com', '_self');
        }
      }, function (error) {
        NotificationService.error(error);
      });
    }, function (response) {
      var data = response.data;
      if (data['user'] && data['user']['email']) {
        NotificationService.error(data['user']['email']);
        return;
      }
      if (data['user'] && data['user']['password']['password:numeric_disallowed']) {
        NotificationService.error(data['user']['password']['password:numeric_disallowed']);
        return;
      }
      if (data['user'] && data['user']['password']['password:number_not_found']) {
        NotificationService.error(data['user']['password']['password:number_not_found']);
        return;
      }
      if (data['user'] && data['user']['password']) {
        NotificationService.error(data['user']['password']);
        return;
      }
      if (data['password']) {
        NotificationService.error('Password must contain a minimum of 8 characters, at least 1 letter and 1 number.');
        return;
      }
      NotificationService.error('Unknown error, please contact site administration.');
    });
  };

  $scope.reset();
};

app.controller('UserRegisterController', ['$scope', '$state', '$window', 'AuthService', 'NotificationService',
  'ngDialog', 'FormErrorsService', 'AuthDataService', UserRegisterController]);
